import script from "./CustomerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDialog.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDialog.vue?vue&type=style&index=0&id=05ab5dfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ab5dfe"]])

export default __exports__